import isNil from "lodash/isNil";

import { isUserPreTreatment } from "@/hooks/usePatientStatus";
import useTransitionTrackStatus from "@/hooks/useTransitionTrackStatus";
import PreAdmissionsGroupBlurb from "@/ui/components/schedule/PreAdmissionsGroupBlurb";
import { isNotNilNotEmpty } from "@/utils/shared.utils";

const TransitionTrackUrl = "https://equip.health/preparing-for-treatment";
const DefaultUrl = "https://equip.health/pre-admissions-group";

interface EmptyListBlurbProps {
  universalStatusCode?: UniversalStatusCode;
  userId?: string;
}

const EmptyListBlurb = ({
  universalStatusCode,
  userId,
}: EmptyListBlurbProps) => {
  const { isUserInTransitionTrack } = useTransitionTrackStatus();

  const contentUrl =
    isNotNilNotEmpty(userId) && isUserInTransitionTrack(userId)
      ? TransitionTrackUrl
      : DefaultUrl;

  if (isNil(universalStatusCode) || !isUserPreTreatment(universalStatusCode)) {
    return null;
  }

  return <PreAdmissionsGroupBlurb contentUrl={contentUrl} />;
};

export { DefaultUrl, TransitionTrackUrl };
export type { EmptyListBlurbProps };
export default EmptyListBlurb;
